import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";
import { installCrashGuard } from "@/crashGuard";

installCrashGuard();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);

// Dismiss the brand splash once the app has painted.
// الجذر القديم لمشكلة «الضغط لا يستجيب»: الإخفاء كان ينتظر window.load
// (اكتمال كل الصور وخطوط وسكربتات الطرف الثالث) — على شبكات الجوال قد يتأخر
// عشرات الثواني والسبلاش (z-index 99999) يبتلع كل الضغطات طوال هذه المدة.
// الآن: يختفي فور أول إطار رسم فعلي من React + مهلة أمان قصوى.
let splashHidden = false;
const hideSplash = () => {
  if (splashHidden) return;
  splashHidden = true;
  const s = document.getElementById("rg-splash");
  if (s) { s.classList.add("hide"); setTimeout(() => s.remove(), 460); }
};
requestAnimationFrame(() => requestAnimationFrame(() => setTimeout(hideSplash, 250)));
if (document.readyState === "complete") setTimeout(hideSplash, 100);
else window.addEventListener("load", () => setTimeout(hideSplash, 100));
setTimeout(hideSplash, 4000);
